import { render, staticRenderFns } from "./ShowSpeak.vue?vue&type=template&id=1ec68b8e&scoped=true&"
import script from "./ShowSpeak.vue?vue&type=script&lang=ts&"
export * from "./ShowSpeak.vue?vue&type=script&lang=ts&"
import style0 from "./ShowSpeak.vue?vue&type=style&index=0&id=1ec68b8e&prod&lang=scss&scoped=true&"
import style1 from "./ShowSpeak.vue?vue&type=style&index=1&id=1ec68b8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec68b8e",
  null
  
)

export default component.exports